import React from 'react'
import styled from 'styled-components'

const StyledSteeringWheel = styled.div`
	font-size: ${({ size }) => size * 0.1}px;
	height: ${({ size }) => size}px;
	width: ${({ size }) => size}px;

	.steering-wheel {
		border: 1.2em solid ${({ color }) => color};
		border-radius: 50%;
		box-sizing: border-box;
		height: 100%;
		overflow: hidden;
		position: relative;
		width: 100%;
	}
	.big-circle {
		background: ${({ color }) => color};
		border-radius: 50%;
		height: 100%;
		left: -30%;
		position: absolute;
		top: 30%;
		width: 160%;
	}
	.circle-left,
	.circle-right {
		background: #fff;
		border-radius: 50%;
		height: 50%;
		left: -15%;
		position: absolute;
		top: 60%;
		width: 50%;
	}
	.circle-right {
		left: 65%;
	}
	.circle-middle {
		background: #fff;
		border-radius: 50%;
		height: 20%;
		left: 40%;
		position: absolute;
		top: 40%;
		width: 20%;
	}
`

const SteeringWheel = ({ size, color }) => (
	<StyledSteeringWheel size={size} color={color}>
		<div className="steering-wheel">
			<div className="big-circle" />
			<div className="circle-left" />
			<div className="circle-right" />
			<div className="circle-middle" />
		</div>
	</StyledSteeringWheel>
)

export default SteeringWheel
